import _ from "lodash";
import { NavLink } from "react-router-dom";

import { List, ListItem, ListItemText, makeStyles } from "@material-ui/core";

import palette from "src/styles/palette";

const useStyles = makeStyles(() => ({
  sidebar: {
    minHeight: "calc(100vh - 80px)",
    width: "240px",
    paddingTop: 20,
    background: palette.lightGray
  },
  sidebarItem: {
    fontSize: 16,
    paddingLeft: 24
  }
}));

export function StaffSidebar(): JSX.Element {
  const classes = useStyles();
  const items = [
    { label: "Tenants", path: "/staff/tenants" },
    { label: "Staff Emails", path: "/staff/emails" },
    { label: "Back to Tenant", path: "/admin/campaigns" }
  ];

  return (
    <div className={classes.sidebar}>
      <List>
        {items.map(({ label, path }, idx) => (
          <ListItem
            key={idx}
            dense
            button
            className={classes.sidebarItem}
            component={NavLink}
            to={path}
            activeStyle={{ fontWeight: 999 }}
          >
            <ListItemText disableTypography primary={label} />
          </ListItem>
        ))}
      </List>
    </div>
  );
}

export { StaffEmailAdmin } from "./StaffEmails";
export { StaffTenantAdmin } from "./Tenants";
